module.exports = __webpack_public_path__ + "img/mau4-65-nhan.6685299c.jpg";